import styled from 'styled-components';
import colors from 'constants/colors';

export const LegendContainer = styled.div`
  width: 100%;
  display: flex;
  column-gap: 120px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 130px;
  box-sizing: border-box;
  margin-top: 50px;

  .legendRow {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .rowLabel {
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-align: left;
      white-space: nowrap;
      color: ${colors.white};
      padding-left: 10px;
    }
    
    .legends {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 10px;
    }
  }
`;

export const LegendItemContainer = styled.div`
  width: 65px;
  height: 55px;

  .iconContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: ${({backgroundColor, borderColor }) => backgroundColor ? backgroundColor : borderColor? colors.black1: colors.white};
    margin: 10px auto;
    ${({borderColor}) => borderColor ?`border: 2px solid ${borderColor}`: null}; 
  }

  .iconLayout {
    width: 20px;
    height: 30px;
  }

  .legendTitle {
    width: 100%;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: center;
    white-space: nowrap;
    color: ${colors.silver};
  }
`;
